import React from 'react';

const AgentsAccountantPage = () => {
  return (
    <div>
      <h1>Accountant Page</h1>
    </div>
  );
};

export { AgentsAccountantPage }; 